{
  "schemaVersion": 1,
  "locale": "es",
  "sourceLocale": "en",
  "entries": {
    "domain:1": {
      "name": "Ciencias de la vida",
      "description": "El estudio de los organismos vivos y los procesos vitales, que abarca la biología, la ecología, la genética, la biología molecular, la agricultura, la zoología, la botánica y los mecanismos fundamentales que rigen la vida desde el nivel molecular hasta el de los ecosistemas"
    },
    "domain:2": {
      "name": "Ciencias sociales",
      "description": "El estudio sistemático de la sociedad humana y las relaciones sociales, que incluye la economía, la psicología, la sociología, las ciencias políticas, la antropología, la educación, el derecho, la lingüística y las humanidades, y examina cómo interactúan las personas y dan forma a las civilizaciones"
    },
    "domain:3": {
      "name": "Ciencias físicas",
      "description": "El estudio de la materia no viva y la energía, que abarca la física, la química, la astronomía, las ciencias de la Tierra, las matemáticas, las ciencias de la computación, la ingeniería y la ciencia de los materiales, y explora las leyes y los principios fundamentales que rigen el mundo natural"
    },
    "domain:4": {
      "name": "Ciencias de la salud",
      "description": "Las ciencias aplicadas dedicadas a mejorar la salud humana y animal mediante la medicina, la enfermería, la odontología, la farmacia, la salud pública, la investigación clínica y los sistemas de prestación de atención sanitaria, con énfasis en la prevención, el diagnóstico y el tratamiento de enfermedades, así como en el bienestar"
    },
    "field:11": {
      "name": "Ciencias agrícolas y biológicas",
      "description": "El estudio de los organismos vivos y sus interacciones con el entorno, que incluye la agricultura, la ecología, la biología vegetal, la biología animal, la conservación, la silvicultura, la biología marina y los sistemas sostenibles de producción de alimentos"
    },
    "field:12": {
      "name": "Artes y humanidades",
      "description": "El estudio de la cultura humana y la expresión creativa, que incluye la literatura, la filosofía, la historia, la lingüística, la música, las artes visuales, las artes escénicas, los estudios culturales y la exploración de los valores, las ideas y los logros artísticos humanos"
    },
    "field:13": {
      "name": "Bioquímica, genética y biología molecular",
      "description": "La base molecular de la vida, que explora los procesos químicos de los organismos vivos, la herencia genética, la estructura y función del ADN y el ARN, la síntesis de proteínas, la biología celular y los mecanismos moleculares subyacentes a los fenómenos biológicos"
    },
    "field:14": {
      "name": "Negocios, gestión y contabilidad",
      "description": "El estudio de las operaciones, la estrategia y la gestión financiera de las organizaciones, que incluye el emprendimiento, el marketing, los recursos humanos, la gestión de operaciones, el liderazgo, las finanzas corporativas, los principios contables y el análisis empresarial"
    },
    "field:15": {
      "name": "Ingeniería química",
      "description": "La aplicación de la química, la física y las matemáticas a los procesos industriales, incluido el diseño de reactores, la optimización de procesos, la síntesis de materiales, las tecnologías de separación, las aplicaciones biotecnológicas y los sistemas de fabricación sostenible"
    },
    "field:16": {
      "name": "Química",
      "description": "El estudio de la materia y sus propiedades, reacciones y transformaciones, que incluye la química orgánica, inorgánica, física y analítica, así como el desarrollo de nuevos materiales y fármacos y la comprensión de las interacciones moleculares"
    },
    "field:17": {
      "name": "Ciencias de la computación",
      "description": "El estudio de la computación, el procesamiento de la información y los sistemas inteligentes, que incluye los algoritmos, la inteligencia artificial, el aprendizaje automático, la ingeniería de software, la ciberseguridad, las bases de datos, las redes y la interacción persona-computadora"
    },
    "field:18": {
      "name": "Ciencias de la decisión",
      "description": "La aplicación de métodos cuantitativos para mejorar la toma de decisiones, que incluye la investigación de operaciones, las ciencias de la gestión, la estadística, el análisis de riesgos, la teoría de juegos, la optimización y los enfoques basados en datos para problemas empresariales y sociales complejos"
    },
    "field:19": {
      "name": "Ciencias de la Tierra y planetarias",
      "description": "El estudio de la Tierra y otros cuerpos celestes, que incluye la geología, la oceanografía, las ciencias atmosféricas, la climatología, la sismología, la formación planetaria, los recursos naturales y los procesos físicos que dan forma a los planetas y sus entornos"
    },
    "field:20": {
      "name": "Economía, econometría y finanzas",
      "description": "El estudio de la asignación de recursos, el comportamiento de los mercados y los sistemas financieros, que incluye la microeconomía, la macroeconomía, el comercio internacional, la política monetaria, los mercados financieros, el análisis de inversiones y la modelización económica cuantitativa"
    },
    "field:21": {
      "name": "Energía",
      "description": "El estudio interdisciplinario de los sistemas y las tecnologías energéticos, que incluye las energías renovables, los combustibles fósiles, la energía nuclear, el almacenamiento de energía, la eficiencia, la sostenibilidad, la mitigación del cambio climático y la transición hacia economías de energía limpia"
    },
    "field:22": {
      "name": "Ingeniería",
      "description": "La aplicación de principios científicos para diseñar y construir sistemas, incluida la ingeniería mecánica, eléctrica, civil, aeroespacial, biomédica e industrial, con énfasis en resolver problemas prácticos e impulsar la innovación tecnológica"
    },
    "field:23": {
      "name": "Ciencias ambientales",
      "description": "El estudio integrado de los procesos físicos, químicos y biológicos del medioambiente, que incluye la ecología, la conservación, la contaminación, el cambio climático, la sostenibilidad, la política ambiental y el impacto de las actividades humanas en los sistemas naturales"
    },
    "field:24": {
      "name": "Inmunología y microbiología",
      "description": "El estudio de los microorganismos y el sistema inmunitario, que incluye las bacterias, los virus, los hongos, los parásitos, las enfermedades infecciosas, las respuestas inmunitarias, las vacunas, los antibióticos y las complejas interacciones entre los patógenos y los mecanismos de defensa del huésped"
    },
    "field:25": {
      "name": "Ciencia de los materiales",
      "description": "El estudio de las propiedades y aplicaciones de los materiales, que incluye los metales, la cerámica, los polímeros, los materiales compuestos, los nanomateriales, los semiconductores y los biomateriales, con énfasis en las relaciones entre estructura y propiedades y en el desarrollo de materiales novedosos"
    },
    "field:26": {
      "name": "Matemáticas",
      "description": "El estudio de estructuras, patrones y relaciones abstractos, que incluye las matemáticas puras (álgebra, análisis, geometría y topología), las matemáticas aplicadas, la estadística, las matemáticas computacionales y los fundamentos matemáticos subyacentes a todas las ciencias"
    },
    "field:27": {
      "name": "Medicina",
      "description": "La ciencia y la práctica del diagnóstico, el tratamiento y la prevención de enfermedades, que incluye la medicina clínica, la cirugía, la medicina interna, la pediatría, la psiquiatría, la investigación médica y el avance de las intervenciones terapéuticas para la salud humana"
    },
    "field:28": {
      "name": "Neurociencia",
      "description": "El estudio científico del sistema nervioso, que incluye la función cerebral, el desarrollo neural, los procesos cognitivos, el comportamiento, los trastornos neurológicos, la conciencia, la memoria, el aprendizaje y la base biológica de los fenómenos mentales"
    },
    "field:29": {
      "name": "Enfermería",
      "description": "El arte y la ciencia de cuidar a las personas durante toda la vida, que incluye la práctica clínica de enfermería, la defensa del paciente, la promoción de la salud, la prevención de enfermedades, la formación en enfermería y la prestación de atención sanitaria compasiva en diversos entornos"
    },
    "field:30": {
      "name": "Farmacología, toxicología y ciencias farmacéuticas",
      "description": "El estudio de los fármacos y sus efectos en los sistemas vivos, que incluye el descubrimiento, desarrollo y suministro de fármacos, la farmacocinética, la toxicología, la química farmacéutica, la farmacia clínica y el uso seguro y eficaz de los medicamentos"
    },
    "field:31": {
      "name": "Física y astronomía",
      "description": "El estudio fundamental de la materia, la energía y el universo, que incluye la mecánica cuántica, la relatividad, la física de partículas, la astrofísica, la cosmología, la física de la materia condensada y la exploración de las leyes naturales que rigen los fenómenos físicos"
    },
    "field:32": {
      "name": "Psicología",
      "description": "El estudio científico de la mente y el comportamiento, que incluye los procesos cognitivos, el desarrollo emocional, las interacciones sociales, la salud mental, la personalidad, el desarrollo humano, la psicología clínica y las bases biológicas de los fenómenos psicológicos"
    },
    "field:33": {
      "name": "Ciencias sociales",
      "description": "El estudio de la sociedad humana y las relaciones sociales, que incluye la sociología, la antropología, las ciencias políticas, la geografía, los estudios de comunicación, las relaciones internacionales, la planificación urbana y el análisis sistemático de las estructuras sociales y las prácticas culturales"
    },
    "field:34": {
      "name": "Veterinaria",
      "description": "La atención médica y el tratamiento de animales, incluidos los animales de compañía, el ganado, la fauna silvestre y las especies exóticas, que abarca la medicina veterinaria, la cirugía, la atención preventiva, la salud pública y el papel fundamental de la salud animal en el bienestar humano"
    },
    "field:35": {
      "name": "Odontología",
      "description": "La rama de la medicina centrada en la salud bucodental, que incluye el diagnóstico, la prevención y el tratamiento de las enfermedades que afectan a los dientes, las encías y las estructuras orales, así como la cirugía oral, la ortodoncia y la relación entre la salud bucodental y la sistémica"
    },
    "field:36": {
      "name": "Profesiones de la salud",
      "description": "Las disciplinas sanitarias afines que apoyan la prestación de atención sanitaria, incluidas la fisioterapia, la terapia ocupacional, la salud pública, la administración sanitaria, la nutrición, la tecnología médica y otros servicios sanitarios especializados"
    },
    "subfield:1100": {
      "name": "Ciencias agrícolas y biológicas generales",
      "description": "Investigación interdisciplinaria amplia que abarca múltiples áreas de la agricultura y la biología, incluidos enfoques integrados de la seguridad alimentaria, aplicaciones biotecnológicas, sostenibilidad ambiental y la interacción entre los sistemas agrícolas y los ecosistemas naturales"
    },
    "subfield:1102": {
      "name": "Agronomía y ciencia de los cultivos",
      "description": "La ciencia de la gestión del suelo y la producción de cultivos, que incluye la mejora vegetal, la fisiología de los cultivos, la fertilidad del suelo, los sistemas de riego, el control de plagas y las prácticas agrícolas sostenibles para optimizar el rendimiento y la calidad"
    },
    "subfield:1103": {
      "name": "Ciencia animal y zoología",
      "description": "El estudio integral de la biología, el comportamiento, la fisiología y la ecología de los animales, que incluye la producción ganadera, la nutrición, la reproducción y el bienestar animal, la conservación de la fauna silvestre y las relaciones evolutivas entre especies animales"
    },
    "subfield:1104": {
      "name": "Ciencias acuáticas",
      "description": "El estudio interdisciplinario de los ecosistemas de agua dulce y marinos, que incluye la limnología, la oceanografía, la ecología acuática, las ciencias pesqueras, la calidad del agua y la conservación de la biodiversidad y los recursos acuáticos"
    },
    "subfield:1105": {
      "name": "Ecología, evolución, comportamiento y sistemática",
      "description": "El estudio integrado de cómo los organismos interactúan con su entorno, evolucionan con el tiempo, presentan comportamientos y se clasifican, que incluye la dinámica de poblaciones, la ecología de comunidades, la biología evolutiva, la ecología del comportamiento y las relaciones taxonómicas"
    },
    "subfield:1106": {
      "name": "Ciencia de los alimentos",
      "description": "La aplicación de las ciencias biológicas, químicas y físicas al estudio de las propiedades, el procesamiento, la conservación, la seguridad y la nutrición de los alimentos, incluida la química, la microbiología y la ingeniería de alimentos, el análisis sensorial y el desarrollo de productos"
    },
    "subfield:1107": {
      "name": "Silvicultura",
      "description": "La ciencia y la práctica de gestionar los ecosistemas forestales para la producción de madera, la conservación, la recreación y los servicios ecosistémicos, que incluye la silvicultura, la ecología forestal, la gestión de incendios y el uso sostenible de los recursos forestales"
    },
    "subfield:1108": {
      "name": "Horticultura",
      "description": "La ciencia y el arte de cultivar frutas, hortalizas, flores y plantas ornamentales, que incluye la propagación vegetal, la gestión de invernaderos, el diseño paisajístico, la tecnología poscosecha y la agricultura urbana"
    },
    "subfield:1109": {
      "name": "Entomología",
      "description": "El estudio de los insectos y sus interacciones con los seres humanos, las plantas y los ecosistemas, que incluye la entomología, el control de plagas, la biología de los polinizadores, la fisiología, el comportamiento y la sistemática de los insectos, y su papel en la agricultura y la transmisión de enfermedades"
    },
    "subfield:1110": {
      "name": "Ciencia vegetal",
      "description": "El estudio integral de la biología vegetal, que incluye la fisiología, la biología molecular, la genética, la patología y la biotecnología vegetales, así como el desarrollo de variedades mejoradas de cultivos para usos alimentarios, textiles y ambientales"
    },
    "subfield:1111": {
      "name": "Ciencia del suelo",
      "description": "El estudio del suelo como recurso natural, que incluye su formación, clasificación, cartografía, fertilidad, química, biología, física y gestión para la producción agrícola y la protección ambiental"
    },
    "subfield:1200": {
      "name": "Artes y humanidades generales",
      "description": "Estudio interdisciplinario que conecta múltiples disciplinas de las humanidades y explora la cultura, la creatividad y la expresión humanas mediante enfoques integrados del arte, la literatura, la historia, la filosofía y los estudios culturales"
    },
    "subfield:1202": {
      "name": "Historia",
      "description": "El estudio y la interpretación sistemáticos de acontecimientos, sociedades y culturas del pasado mediante fuentes primarias, archivos y métodos historiográficos, que examina los cambios políticos, sociales, económicos y culturales a lo largo del tiempo y en distintas regiones"
    },
    "subfield:1203": {
      "name": "Lengua y lingüística",
      "description": "El estudio científico de la estructura, la adquisición, el uso y la evolución del lenguaje humano, que incluye la fonética, la sintaxis, la semántica, la pragmática, la sociolingüística y la documentación de lenguas en peligro de extinción"
    },
    "subfield:1204": {
      "name": "Arqueología",
      "description": "El estudio científico de la historia y la prehistoria humanas mediante la excavación y el análisis de objetos, estructuras y restos culturales, que incluye métodos de campo, técnicas de datación e interpretaciones de sociedades del pasado"
    },
    "subfield:1205": {
      "name": "Estudios clásicos",
      "description": "El estudio de las civilizaciones griega y romana antiguas, incluidas sus lenguas, literatura, historia, filosofía, arte y legado cultural, mediante el examen de textos, evidencias arqueológicas y su influencia en la sociedad moderna"
    },
    "subfield:1206": {
      "name": "Conservación",
      "description": "La preservación y restauración del patrimonio cultural, incluidas las obras de arte, los documentos históricos, los objetos arqueológicos y los monumentos arquitectónicos, mediante análisis científicos, prácticas éticas y estrategias de conservación preventiva"
    },
    "subfield:1207": {
      "name": "Historia y filosofía de la ciencia",
      "description": "El examen del desarrollo, la metodología y la epistemología de la ciencia a lo largo de la historia, que analiza cómo se construye, valida y transforma el conocimiento científico, incluidos los contextos sociales y culturales de la práctica científica"
    },
    "subfield:1208": {
      "name": "Literatura y teoría literaria",
      "description": "El análisis y la interpretación de textos escritos de distintas culturas y épocas, que incluye la teoría crítica, la literatura comparada, los estudios de género literario, el análisis narrativo y la exploración del papel de la literatura en la sociedad y la experiencia humana"
    },
    "subfield:1209": {
      "name": "Museología",
      "description": "La teoría y la práctica de las operaciones de los museos, que incluye la gestión de colecciones, el diseño de exposiciones, los programas educativos, la curaduría digital, la participación del público y el papel de los museos en la preservación e interpretación del patrimonio cultural"
    },
    "subfield:1210": {
      "name": "Música",
      "description": "El estudio académico de la música en todas sus formas, que incluye la teoría musical, la composición, la interpretación, la etnomusicología, la historia de la música, la acústica y los aspectos culturales, sociales y cognitivos de la expresión musical"
    },
    "subfield:1211": {
      "name": "Filosofía",
      "description": "La investigación sistemática de cuestiones fundamentales sobre la existencia, el conocimiento, los valores, la razón, la mente y el lenguaje, que incluye la metafísica, la epistemología, la ética, la lógica, la estética y la filosofía política"
    },
    "subfield:1212": {
      "name": "Estudios religiosos",
      "description": "El examen académico de creencias, prácticas, instituciones y experiencias religiosas en distintas culturas, que incluye la religión comparada, la teología, los textos sagrados, los estudios rituales y el papel de la religión en la sociedad contemporánea"
    },
    "subfield:1213": {
      "name": "Artes visuales y escénicas",
      "description": "El estudio y la práctica de la expresión artística mediante medios visuales y escénicos, que incluye la pintura, la escultura, la fotografía, el teatro, la danza, el cine y las artes digitales, y examina tanto los procesos creativos como el análisis crítico"
    },
    "subfield:1300": {
      "name": "Bioquímica, genética y biología molecular generales",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de la bioquímica, la genética y la biología molecular y conecta los límites tradicionales de este campo"
    },
    "subfield:1302": {
      "name": "Envejecimiento",
      "description": "El estudio biológico de los procesos de envejecimiento en los niveles molecular, celular y del organismo, que incluye los mecanismos de senescencia, las enfermedades relacionadas con la edad, la longevidad, la medicina regenerativa y las intervenciones para promover un envejecimiento saludable"
    },
    "subfield:1303": {
      "name": "Bioquímica",
      "description": "Los procesos y sustancias químicos de los organismos vivos, con el estudio de las proteínas, los ácidos nucleicos, los carbohidratos, los lípidos y sus interacciones, incluida la función de las enzimas, las vías metabólicas y los mecanismos moleculares de la vida"
    },
    "subfield:1304": {
      "name": "Biofísica",
      "description": "La aplicación de principios y métodos físicos para comprender los sistemas biológicos, incluida la estructura y dinámica biomoleculares, la biofísica de membranas, la mecánica celular y el desarrollo de técnicas biofísicas"
    },
    "subfield:1305": {
      "name": "Biotecnología",
      "description": "La aplicación de sistemas biológicos y organismos para desarrollar productos y tecnologías, que incluye la ingeniería genética, la biología sintética, los biofármacos, la biotecnología industrial y las aplicaciones de la biotecnología agrícola"
    },
    "subfield:1306": {
      "name": "Investigación del cáncer",
      "description": "El estudio multidisciplinario de la biología del cáncer, que incluye la carcinogénesis, la progresión tumoral, la metástasis, la genética y la inmunología del cáncer, y el desarrollo de estrategias diagnósticas, preventivas y terapéuticas"
    },
    "subfield:1307": {
      "name": "Biología celular",
      "description": "El estudio de la estructura, la función y el comportamiento de las células, que incluye los orgánulos, la división celular, la señalización, el metabolismo, la diferenciación y los mecanismos moleculares que rigen los procesos celulares en la salud y la enfermedad"
    },
    "subfield:1308": {
      "name": "Bioquímica clínica",
      "description": "El análisis de líquidos corporales y tejidos para el diagnóstico y la supervisión terapéutica, que incluye el desarrollo de biomarcadores, los análisis clínicos, las pruebas en el punto de atención y la base bioquímica de las enfermedades"
    },
    "subfield:1309": {
      "name": "Biología del desarrollo",
      "description": "El estudio de cómo crecen y se desarrollan los organismos desde la fecundación hasta la madurez, que incluye la embriogénesis, la morfogénesis, la diferenciación celular, la formación de patrones, la biología de células madre y la regeneración"
    },
    "subfield:1310": {
      "name": "Endocrinología",
      "description": "El estudio de las hormonas y el sistema endocrino, que incluye la síntesis, la secreción y la acción hormonales, los trastornos endocrinos, la neuroendocrinología y la regulación del metabolismo, el crecimiento y la reproducción"
    },
    "subfield:1311": {
      "name": "Genética",
      "description": "El estudio de la herencia y la variación genética, que incluye la genética molecular, la genética de poblaciones, la genómica, la epigenética, la ingeniería genética y la base genética de los rasgos, la evolución y las enfermedades"
    },
    "subfield:1312": {
      "name": "Biología molecular",
      "description": "Los mecanismos moleculares de los procesos biológicos, con énfasis en las interacciones entre el ADN, el ARN y las proteínas, la expresión génica, la transducción de señales, las técnicas moleculares y la base molecular de la función celular"
    },
    "subfield:1313": {
      "name": "Medicina molecular",
      "description": "La aplicación de la biología molecular para comprender y tratar enfermedades, que incluye el diagnóstico molecular, la medicina personalizada, la terapia génica, el desarrollo de fármacos y la investigación traslacional desde el laboratorio hasta la práctica clínica"
    },
    "subfield:1314": {
      "name": "Fisiología",
      "description": "El estudio del funcionamiento de los organismos en todos los niveles, desde las moléculas hasta los sistemas de órganos, que incluye la fisiología cardiovascular, respiratoria, neural, renal y digestiva, la homeostasis y la adaptación a los desafíos ambientales"
    },
    "subfield:1315": {
      "name": "Biología estructural",
      "description": "La determinación y el análisis de las estructuras tridimensionales de las macromoléculas biológicas mediante técnicas como la cristalografía, la RMN y la crio-ME para comprender las relaciones entre estructura y función y el diseño de fármacos"
    },
    "subfield:1400": {
      "name": "Negocios, gestión y contabilidad generales",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de los negocios, la gestión y la contabilidad y conecta los límites tradicionales de este campo"
    },
    "subfield:1402": {
      "name": "Contabilidad",
      "description": "La medición, el procesamiento y la comunicación de información financiera, que incluye la contabilidad financiera y de gestión, la auditoría, la tributación, la contabilidad forense y los sistemas de información contable"
    },
    "subfield:1403": {
      "name": "Negocios y gestión internacional",
      "description": "El estudio de las operaciones empresariales mundiales y la gestión intercultural, que incluye la estrategia internacional, las cadenas mundiales de suministro, la entrada en mercados extranjeros, las empresas multinacionales y la gestión de la diversidad en contextos internacionales"
    },
    "subfield:1404": {
      "name": "Sistemas de información de gestión",
      "description": "El diseño, la implantación y la gestión de la tecnología de la información en las organizaciones, que incluye los sistemas empresariales, la inteligencia empresarial, la estrategia de TI, la gestión de la ciberseguridad y la transformación digital"
    },
    "subfield:1405": {
      "name": "Gestión de la tecnología y la innovación",
      "description": "La gestión estratégica del cambio tecnológico y los procesos de innovación, que incluye la gestión de I+D, la transferencia de tecnología, los ecosistemas de innovación, la propiedad intelectual y la comercialización de nuevas tecnologías"
    },
    "subfield:1406": {
      "name": "Marketing",
      "description": "El estudio de la dinámica de los mercados y el comportamiento del consumidor para crear, comunicar y ofrecer valor, que incluye la investigación de mercados, la gestión de marcas, el marketing digital, la psicología del consumidor, las estrategias de precios y el análisis de marketing"
    },
    "subfield:1407": {
      "name": "Comportamiento organizacional y gestión de recursos humanos",
      "description": "El estudio del comportamiento humano en las organizaciones y la gestión del capital humano, que incluye el liderazgo, la motivación, la dinámica de equipos, la cultura organizacional, la gestión del talento y el desarrollo de los empleados"
    },
    "subfield:1408": {
      "name": "Estrategia y gestión",
      "description": "La formulación e implantación de estrategias organizacionales para lograr ventajas competitivas, que incluye la planificación estratégica, el gobierno corporativo, el diseño organizacional, la gestión del cambio y la medición del desempeño"
    },
    "subfield:1409": {
      "name": "Gestión del turismo, el ocio y la hostelería",
      "description": "La gestión de destinos turísticos, servicios de hostelería y actividades de ocio, que incluye el turismo sostenible, el marketing de destinos, la gestión de hoteles y restaurantes, la planificación de eventos y el comportamiento de los turistas"
    },
    "subfield:1410": {
      "name": "Relaciones laborales",
      "description": "El estudio de las relaciones de empleo entre trabajadores, empleadores y gobiernos, que incluye los sindicatos, la negociación colectiva, la resolución de conflictos laborales, el derecho laboral y las políticas de recursos humanos"
    },
    "subfield:1500": {
      "name": "Ingeniería química general",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de la ingeniería química y conecta los límites tradicionales de este campo"
    },
    "subfield:1502": {
      "name": "Bioingeniería",
      "description": "La aplicación de principios de ingeniería a sistemas biológicos, que incluye la ingeniería de bioprocesos, la ingeniería metabólica, el diseño de biorreactores, la tecnología de fermentación y la producción de biofármacos y biomateriales"
    },
    "subfield:1503": {
      "name": "Catálisis",
      "description": "La ciencia de acelerar reacciones químicas mediante catalizadores, que incluye la catálisis heterogénea y homogénea, la catálisis enzimática, el diseño de catalizadores, los mecanismos de reacción y los procesos catalíticos industriales"
    },
    "subfield:1504": {
      "name": "Salud y seguridad químicas",
      "description": "La manipulación, el almacenamiento y la eliminación seguros de sustancias químicas en entornos industriales y de laboratorio, que incluye la evaluación de peligros, el control de la exposición, la respuesta a emergencias, el cumplimiento normativo y la gestión de la seguridad de los procesos"
    },
    "subfield:1506": {
      "name": "Filtración y separación",
      "description": "El diseño y la optimización de procesos de separación, que incluye la tecnología de membranas, la cromatografía, la destilación, la extracción, la cristalización y el desarrollo de materiales y métodos de separación novedosos"
    },
    "subfield:1507": {
      "name": "Flujo de fluidos y procesos de transferencia",
      "description": "El estudio de la dinámica de fluidos y la transferencia de calor y masa en procesos químicos, que incluye el diseño de reactores, la mezcla, el flujo multifásico, la dinámica de fluidos computacional y los fenómenos de transporte en aplicaciones industriales"
    },
    "subfield:1508": {
      "name": "Química y tecnología de procesos",
      "description": "El desarrollo y la optimización de procesos de fabricación química, que incluye la intensificación de procesos, la química verde, el escalado, el procesamiento continuo y la integración de operaciones unitarias para una producción eficiente"
    },
    "subfield:1600": {
      "name": "Química general",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de la química y conecta los límites tradicionales de este campo"
    },
    "subfield:1602": {
      "name": "Química analítica",
      "description": "El desarrollo y la aplicación de métodos para identificar y cuantificar la materia, que incluye la espectroscopia, la cromatografía, la espectrometría de masas, las técnicas electroanalíticas y los sensores químicos para diversas aplicaciones"
    },
    "subfield:1603": {
      "name": "Electroquímica",
      "description": "El estudio de procesos químicos que implican transferencia de electrones, que incluye las baterías, las pilas de combustible, la corrosión, la galvanoplastia, el electroanálisis y el desarrollo de sensores electroquímicos y dispositivos de almacenamiento de energía"
    },
    "subfield:1604": {
      "name": "Química inorgánica",
      "description": "El estudio de compuestos y materiales inorgánicos, que incluye la química de coordinación, la química organometálica, la química del estado sólido, la química bioinorgánica y la síntesis de materiales inorgánicos avanzados"
    },
    "subfield:1605": {
      "name": "Química orgánica",
      "description": "El estudio de compuestos que contienen carbono, que incluye la síntesis, los mecanismos de reacción, la estereoquímica, los productos naturales, la química medicinal y el desarrollo de nuevas metodologías de síntesis"
    },
    "subfield:1606": {
      "name": "Química física y teórica",
      "description": "El estudio de fenómenos químicos mediante la física y modelos matemáticos, que incluye la termodinámica, la cinética, la química cuántica, la mecánica estadística y los métodos de química computacional"
    },
    "subfield:1607": {
      "name": "Espectroscopia",
      "description": "El estudio de la interacción de la materia con la radiación electromagnética, que incluye la RMN, el IR, el UV-Vis, la espectroscopia Raman y técnicas espectroscópicas avanzadas para el análisis estructural y la identificación química"
    },
    "subfield:1700": {
      "name": "Ciencias de la computación generales",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de las ciencias de la computación y conecta los límites tradicionales de este campo"
    },
    "subfield:1702": {
      "name": "Inteligencia artificial",
      "description": "El desarrollo de sistemas inteligentes capaces de percibir, razonar, aprender y actuar, que incluye el aprendizaje automático, el aprendizaje profundo, el procesamiento del lenguaje natural, la robótica, los sistemas expertos y la ética de la IA"
    },
    "subfield:1703": {
      "name": "Teoría computacional y matemáticas",
      "description": "Los fundamentos matemáticos de la computación, que incluyen los algoritmos, la teoría de la complejidad, la teoría de autómatas, los lenguajes formales, la criptografía y los límites teóricos de la computación"
    },
    "subfield:1704": {
      "name": "Gráficos por computadora y diseño asistido por computadora",
      "description": "La creación y manipulación de contenido visual mediante computadoras, que incluye el modelado 3D, el renderizado, la animación, la visualización, la realidad virtual, los sistemas CAD/CAM y la geometría computacional"
    },
    "subfield:1705": {
      "name": "Redes y comunicaciones informáticas",
      "description": "El diseño y análisis de sistemas y redes de comunicación, que incluye los protocolos, las redes inalámbricas, la arquitectura de Internet, la seguridad de redes, los sistemas distribuidos y las tecnologías de redes emergentes"
    },
    "subfield:1706": {
      "name": "Aplicaciones de las ciencias de la computación",
      "description": "La aplicación práctica de la computación para resolver problemas del mundo real, que incluye la bioinformática, la ciencia computacional, las humanidades digitales, el comercio electrónico, la computación social y las soluciones de software específicas de cada ámbito"
    },
    "subfield:1707": {
      "name": "Visión por computadora y reconocimiento de patrones",
      "description": "La extracción e interpretación automáticas de información a partir de imágenes y videos, que incluye la detección de objetos, el reconocimiento facial, el análisis de imágenes médicas, los vehículos autónomos y los sistemas de comprensión visual"
    },
    "subfield:1708": {
      "name": "Hardware y arquitectura",
      "description": "El diseño y la organización de sistemas informáticos, que incluye la arquitectura de procesadores, los sistemas de memoria, la computación paralela, los sistemas integrados, el hardware de computación cuántica y la computación de bajo consumo energético"
    },
    "subfield:1709": {
      "name": "Interacción persona-computadora",
      "description": "El diseño y la evaluación de interfaces de usuario y sistemas interactivos, que incluye la usabilidad, la experiencia de usuario, la accesibilidad, la computación móvil, la realidad aumentada y los aspectos sociales de la computación"
    },
    "subfield:1710": {
      "name": "Sistemas de información",
      "description": "El estudio de cómo utilizan las organizaciones la tecnología de la información, que incluye los sistemas de bases de datos, la recuperación de información, la gestión del conocimiento, los sistemas empresariales y los aspectos sociotécnicos de la implantación de TI"
    },
    "subfield:1711": {
      "name": "Procesamiento de señales",
      "description": "El análisis y la manipulación de señales, que incluye el procesamiento digital de señales, el procesamiento de imágenes y audio, la compresión, el filtrado y las aplicaciones en comunicaciones y multimedia"
    },
    "subfield:1712": {
      "name": "Software",
      "description": "La ingeniería de sistemas de software, que incluye los lenguajes de programación, la arquitectura de software, las pruebas, la verificación, los métodos ágiles, DevOps y la gestión de proyectos de software a gran escala"
    },
    "subfield:1800": {
      "name": "Ciencias de la decisión generales",
      "description": "Enfoques interdisciplinarios de la toma de decisiones que combinan múltiples metodologías, incluida la teoría conductual de la decisión, el análisis multicriterio y los marcos integrados para problemas de decisión complejos"
    },
    "subfield:1802": {
      "name": "Sistemas y gestión de la información",
      "description": "El uso estratégico de los sistemas de información para apoyar la toma de decisiones, que incluye la inteligencia empresarial, el análisis de datos, los sistemas de gestión del conocimiento y el gobierno de TI para la toma de decisiones organizacionales"
    },
    "subfield:1803": {
      "name": "Ciencias de la gestión e investigación de operaciones",
      "description": "Métodos matemáticos y analíticos para la toma óptima de decisiones, que incluyen la programación lineal, la simulación, la teoría de colas, la optimización de cadenas de suministro y los modelos cuantitativos para operaciones empresariales"
    },
    "subfield:1804": {
      "name": "Estadística, probabilidad e incertidumbre",
      "description": "Marcos matemáticos para analizar datos e incertidumbre, que incluyen la inferencia estadística, los métodos bayesianos, el análisis de riesgos, los procesos estocásticos y la toma de decisiones en condiciones de incertidumbre"
    },
    "subfield:1900": {
      "name": "Ciencias de la Tierra y planetarias generales",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de las ciencias de la Tierra y planetarias y conecta los límites tradicionales de este campo"
    },
    "subfield:1902": {
      "name": "Ciencias atmosféricas",
      "description": "El estudio de la atmósfera terrestre y sus procesos, que incluye la meteorología, la climatología, la química atmosférica, la calidad del aire, la predicción meteorológica y los efectos de las actividades humanas en la composición atmosférica"
    },
    "subfield:1904": {
      "name": "Procesos de la superficie terrestre",
      "description": "El estudio de los procesos que dan forma a la superficie terrestre, que incluye la geomorfología, la erosión, la sedimentación, la glaciología, la hidrología y las interacciones entre el clima, la tectónica y la evolución del paisaje"
    },
    "subfield:1906": {
      "name": "Geoquímica y petrología",
      "description": "La composición química y la formación de rocas y minerales, que incluye los procesos ígneos, metamórficos y sedimentarios, la geoquímica isotópica y el ciclo de los elementos en los sistemas terrestres"
    },
    "subfield:1907": {
      "name": "Geología",
      "description": "El estudio integral de la estructura, la composición y la historia de la Tierra, que incluye la mineralogía, la estratigrafía, la geología estructural, la geología económica y la reconstrucción del pasado geológico de la Tierra"
    },
    "subfield:1908": {
      "name": "Geofísica",
      "description": "La física de la Tierra y su entorno, que incluye la sismología, la gravedad, el magnetismo, los métodos eléctricos y el uso de técnicas geofísicas para explorar el interior terrestre y los recursos naturales"
    },
    "subfield:1910": {
      "name": "Oceanografía",
      "description": "El estudio multidisciplinario de los océanos, que incluye la oceanografía física, la química marina, la oceanografía biológica, la circulación oceánica, los ecosistemas marinos y las interacciones entre el océano y la atmósfera"
    },
    "subfield:1911": {
      "name": "Paleontología",
      "description": "El estudio de la vida antigua mediante fósiles, que incluye la evolución, la extinción, la paleoecología, la bioestratigrafía y la reconstrucción de entornos y biodiversidad del pasado a lo largo del tiempo geológico"
    },
    "subfield:1912": {
      "name": "Ciencias espaciales y planetarias",
      "description": "El estudio de los cuerpos celestes y los entornos espaciales, que incluye la geología planetaria, la astrobiología, la formación del sistema solar, los exoplanetas, la meteorología espacial y las misiones para explorar otros mundos"
    },
    "subfield:2000": {
      "name": "Economía, econometría y finanzas generales",
      "description": "Investigación económica y financiera amplia que abarca múltiples subcampos, incluidos trabajos interdisciplinarios sobre desarrollo económico, sistemas financieros, economía monetaria y modelización económico-financiera integrada"
    },
    "subfield:2002": {
      "name": "Economía y econometría",
      "description": "La teoría económica y el análisis cuantitativo de fenómenos económicos, que incluyen la teoría microeconómica y macroeconómica, la modelización econométrica, la inferencia causal y la comprobación empírica de hipótesis económicas"
    },
    "subfield:2003": {
      "name": "Finanzas",
      "description": "El estudio de los mercados financieros, las instituciones y la toma de decisiones, que incluye las finanzas corporativas, las inversiones, los derivados financieros, la gestión de riesgos, las finanzas conductuales y la regulación financiera"
    },
    "subfield:2100": {
      "name": "Energía general",
      "description": "Estudios integrales de la energía que abarcan múltiples fuentes y sistemas energéticos, incluida la política, la economía, la seguridad y la sostenibilidad energéticas, así como la integración de diversas tecnologías energéticas"
    },
    "subfield:2102": {
      "name": "Ingeniería energética y tecnología eléctrica",
      "description": "El diseño y la operación de sistemas de conversión de energía y generación eléctrica, que incluye las centrales térmicas, las tecnologías de energías renovables, el almacenamiento de energía, las redes inteligentes y la optimización de la eficiencia energética"
    },
    "subfield:2103": {
      "name": "Tecnología de combustibles",
      "description": "La producción, el procesamiento y el uso de combustibles, incluidos los combustibles fósiles, los biocombustibles, el hidrógeno, los combustibles sintéticos, la tecnología de combustión y el desarrollo de alternativas más limpias"
    },
    "subfield:2104": {
      "name": "Energía e ingeniería nucleares",
      "description": "La generación y las aplicaciones de la energía nuclear, que incluyen el diseño de reactores, el ciclo del combustible nuclear, la protección radiológica, la investigación sobre energía de fusión y la gestión de residuos nucleares y el desmantelamiento"
    },
    "subfield:2105": {
      "name": "Energías renovables, sostenibilidad y medioambiente",
      "description": "Sistemas y tecnologías de energía sostenible, que incluyen la energía solar, eólica, hidroeléctrica, geotérmica y de biomasa, la evaluación del ciclo de vida, la mitigación del carbono y los impactos ambientales de los sistemas energéticos"
    },
    "subfield:2200": {
      "name": "Ingeniería general",
      "description": "Investigación y formación interdisciplinarias en ingeniería que abarcan los principios fundamentales de la ingeniería, el pensamiento sistémico, la metodología del diseño de ingeniería y los desafíos transversales de la ingeniería"
    },
    "subfield:2202": {
      "name": "Ingeniería aeroespacial",
      "description": "El diseño y desarrollo de aeronaves y naves espaciales, que incluye la aerodinámica, la propulsión, las estructuras, la aviónica, la mecánica orbital y los desafíos de ingeniería del vuelo atmosférico y espacial"
    },
    "subfield:2203": {
      "name": "Ingeniería automotriz",
      "description": "El diseño y la fabricación de vehículos, que incluye los sistemas de propulsión, los sistemas de chasis, la dinámica vehicular, los vehículos autónomos y eléctricos, los sistemas de seguridad y las tecnologías de transporte sostenible"
    },
    "subfield:2204": {
      "name": "Ingeniería biomédica",
      "description": "La aplicación de la ingeniería a la medicina y la biología, que incluye los dispositivos médicos, los biomateriales, la ingeniería de tejidos, las imágenes médicas, la biomecánica y el desarrollo de tecnologías diagnósticas y terapéuticas"
    },
    "subfield:2205": {
      "name": "Ingeniería civil y estructural",
      "description": "El diseño y análisis de infraestructuras y estructuras, incluidos puentes, edificios, presas, sistemas de transporte, la ingeniería sísmica y el desarrollo de infraestructuras civiles resilientes"
    },
    "subfield:2206": {
      "name": "Mecánica computacional",
      "description": "Métodos numéricos para resolver problemas mecánicos, que incluyen el análisis de elementos finitos, la dinámica de fluidos computacional, la modelización multiescala y la simulación de sistemas de ingeniería complejos"
    },
    "subfield:2207": {
      "name": "Ingeniería de control y sistemas",
      "description": "El diseño de sistemas de control para procesos dinámicos, que incluye el control por retroalimentación, la robótica, la automatización, los sistemas adaptativos y la integración de sensores y actuadores en sistemas inteligentes"
    },
    "subfield:2208": {
      "name": "Ingeniería eléctrica y electrónica",
      "description": "El estudio y la aplicación de la electricidad y la electrónica, que incluye los sistemas eléctricos, la electrónica, las telecomunicaciones, el procesamiento de señales, el electromagnetismo y el diseño de dispositivos y sistemas eléctricos"
    },
    "subfield:2209": {
      "name": "Ingeniería industrial y de fabricación",
      "description": "La optimización de procesos y sistemas complejos, que incluye la planificación de la producción, el control de calidad, la gestión de cadenas de suministro, la fabricación ajustada, la automatización y las tecnologías de la Industria 4.0"
    },
    "subfield:2210": {
      "name": "Ingeniería mecánica",
      "description": "El diseño y análisis de sistemas mecánicos, que incluye la termodinámica, la mecánica de fluidos, el diseño de máquinas, la robótica, los sistemas de climatización y el desarrollo de tecnologías mecánicas innovadoras"
    },
    "subfield:2211": {
      "name": "Mecánica de materiales",
      "description": "El comportamiento de materiales sólidos en distintas condiciones, que incluye el análisis de tensiones, la mecánica de fractura, la fatiga, los materiales compuestos y el desarrollo de materiales estructurales avanzados"
    },
    "subfield:2212": {
      "name": "Ingeniería oceánica",
      "description": "La ingeniería para entornos marinos, que incluye las estructuras mar adentro, la arquitectura naval, los vehículos submarinos, la energía oceánica renovable, la ingeniería costera y los sistemas de tecnología marina"
    },
    "subfield:2213": {
      "name": "Seguridad, riesgo, fiabilidad y calidad",
      "description": "Enfoques de ingeniería para la seguridad y fiabilidad de los sistemas, que incluyen la evaluación de riesgos, el análisis de fallos, el aseguramiento de la calidad, los factores humanos y el diseño de sistemas tolerantes a fallos"
    },
    "subfield:2214": {
      "name": "Tecnología de medios",
      "description": "Aspectos de ingeniería de la producción y distribución de medios, que incluyen la tecnología de audio y video, los sistemas de transmisión en continuo, la producción virtual, la ingeniería de radiodifusión y las plataformas de medios emergentes"
    },
    "subfield:2215": {
      "name": "Edificación y construcción",
      "description": "Métodos, materiales y gestión de la construcción, que incluyen la construcción sostenible, el modelado de información de construcción, la seguridad en la obra, la gestión de proyectos y las innovaciones en tecnología de edificación"
    },
    "subfield:2216": {
      "name": "Arquitectura",
      "description": "El arte y la ciencia de diseñar edificios y espacios, que incluye la teoría arquitectónica, el diseño sostenible, la planificación urbana, la tecnología de la edificación, la conservación histórica y los impactos sociales de los entornos construidos"
    },
    "subfield:2300": {
      "name": "Ciencias ambientales generales",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de las ciencias ambientales y conecta los límites tradicionales de este campo"
    },
    "subfield:2302": {
      "name": "Modelización ecológica",
      "description": "Enfoques matemáticos y computacionales para comprender los ecosistemas, que incluyen la dinámica de poblaciones, los modelos de redes tróficas, la valoración de servicios ecosistémicos y la modelización predictiva de respuestas ecológicas"
    },
    "subfield:2303": {
      "name": "Ecología",
      "description": "El estudio de las interacciones entre los organismos y su entorno, que incluye la ecología de comunidades, ecosistemas y paisajes, la biología de la conservación y los patrones y procesos de la biodiversidad"
    },
    "subfield:2304": {
      "name": "Química ambiental",
      "description": "Los procesos químicos del medioambiente, que incluyen el destino y transporte de contaminantes, la química atmosférica, acuática y del suelo, y el desarrollo de soluciones de química verde"
    },
    "subfield:2305": {
      "name": "Ingeniería ambiental",
      "description": "Soluciones de ingeniería para la protección ambiental, que incluyen el tratamiento de agua y aguas residuales, el control de la contaminación atmosférica, la gestión de residuos sólidos, las tecnologías de remediación y el diseño de ingeniería sostenible"
    },
    "subfield:2306": {
      "name": "Cambio global y planetario",
      "description": "Cambios ambientales a gran escala, que incluyen el cambio climático, los ciclos biogeoquímicos, el cambio de uso del suelo, el aumento del nivel del mar y los efectos de las actividades humanas en los procesos del sistema terrestre"
    },
    "subfield:2307": {
      "name": "Salud, toxicología y mutagénesis",
      "description": "Los impactos ambientales en la salud humana, que incluyen la evaluación de la exposición, la ecotoxicología, la epidemiología ambiental, la evaluación de riesgos y los efectos de los contaminantes en el material genético"
    },
    "subfield:2308": {
      "name": "Gestión, supervisión, política y derecho",
      "description": "La gobernanza y gestión ambientales, que incluyen la política y la regulación ambientales, los sistemas de supervisión, la evaluación de impacto ambiental y los acuerdos ambientales internacionales"
    },
    "subfield:2309": {
      "name": "Conservación de la naturaleza y el paisaje",
      "description": "La ciencia y la práctica de la conservación, que incluyen la gestión de áreas protegidas, la restauración de hábitats, la conservación de especies, la ecología del paisaje y la integración de las actividades humanas con los objetivos de conservación"
    },
    "subfield:2310": {
      "name": "Contaminación",
      "description": "El estudio y control de la contaminación ambiental, incluida la contaminación del aire, el agua y el suelo, la contaminación acústica y por plásticos, la prevención de la contaminación y el desarrollo de tecnologías de limpieza"
    },
    "subfield:2311": {
      "name": "Ingeniería industrial y de fabricación",
      "description": "La fabricación sostenible y la ecología industrial, que incluyen la producción más limpia, la evaluación del ciclo de vida, la economía circular, el ecodiseño y la optimización ambiental de los procesos industriales"
    },
    "subfield:2312": {
      "name": "Ciencia y tecnología del agua",
      "description": "Todos los aspectos de los recursos hídricos, que incluyen la hidrología, la calidad del agua, los ecosistemas acuáticos, las tecnologías de tratamiento, la gestión de recursos hídricos y las soluciones para la escasez de agua"
    },
    "subfield:2400": {
      "name": "Inmunología y microbiología generales",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de la inmunología y la microbiología y conecta los límites tradicionales de este campo"
    },
    "subfield:2402": {
      "name": "Microbiología aplicada y biotecnología",
      "description": "La aplicación práctica de microorganismos, que incluye la fermentación industrial, la biorremediación, la producción microbiana de sustancias químicas y materiales, los probióticos y las innovaciones en biotecnología microbiana"
    },
    "subfield:2403": {
      "name": "Inmunología",
      "description": "El estudio de los sistemas inmunitarios de todos los organismos, que incluye la inmunidad innata y adaptativa, los trastornos inmunológicos, las vacunas, la inmunología de los trasplantes y los enfoques terapéuticos inmunológicos"
    },
    "subfield:2404": {
      "name": "Microbiología",
      "description": "El estudio de los microorganismos, incluidas las bacterias, los virus, los hongos y los protozoos, su genética, fisiología, ecología y evolución, y su papel en la salud, las enfermedades y el medioambiente"
    },
    "subfield:2405": {
      "name": "Parasitología",
      "description": "El estudio de los parásitos y las enfermedades parasitarias, que incluye la biología de los parásitos, las interacciones entre huésped y parásito, la epidemiología de las infecciones parasitarias y el desarrollo de intervenciones antiparasitarias"
    },
    "subfield:2406": {
      "name": "Virología",
      "description": "El estudio de los virus y las enfermedades víricas, que incluye la estructura, replicación, patogenia y evolución virales, los fármacos antivirales, los vectores virales y las amenazas víricas emergentes para la salud humana y animal"
    },
    "subfield:2500": {
      "name": "Ciencia de los materiales general",
      "description": "Investigación fundamental de materiales que abarca múltiples clases, incluida la caracterización de materiales, las relaciones entre procesamiento, estructura y propiedades, y los fenómenos transversales de los materiales"
    },
    "subfield:2502": {
      "name": "Biomateriales",
      "description": "Materiales para aplicaciones médicas y biológicas, incluidos implantes, andamios para ingeniería de tejidos, sistemas de administración de fármacos, biocompatibilidad y la interacción entre los materiales y los sistemas biológicos"
    },
    "subfield:2503": {
      "name": "Cerámica y materiales compuestos",
      "description": "Materiales cerámicos avanzados y sistemas compuestos, que incluyen cerámicas estructurales y funcionales, compuestos reforzados con fibras, nanocompuestos y materiales para altas temperaturas"
    },
    "subfield:2504": {
      "name": "Materiales electrónicos, ópticos y magnéticos",
      "description": "Materiales para aplicaciones electrónicas y fotónicas, incluidos los semiconductores, los superconductores, los materiales magnéticos, los cristales fotónicos, los metamateriales y los materiales cuánticos"
    },
    "subfield:2505": {
      "name": "Química de materiales",
      "description": "Enfoques químicos para la síntesis y modificación de materiales, que incluyen el procesamiento sol-gel, el autoensamblaje, la química de superficies, los materiales catalíticos y los nanomateriales obtenidos por métodos químicos"
    },
    "subfield:2506": {
      "name": "Metales y aleaciones",
      "description": "Los materiales metálicos y sus propiedades, que incluyen el diseño de aleaciones, la metalurgia, la corrosión, el procesamiento de metales, las aleaciones de alta entropía y los materiales metálicos avanzados para aplicaciones estructurales"
    },
    "subfield:2507": {
      "name": "Polímeros y plásticos",
      "description": "Materiales poliméricos sintéticos y naturales, que incluyen la síntesis, caracterización y procesamiento de polímeros, la física de polímeros, los polímeros biodegradables y los sistemas poliméricos funcionales"
    },
    "subfield:2508": {
      "name": "Superficies, revestimientos y películas",
      "description": "Ingeniería de superficies y tecnologías de películas delgadas, que incluyen la modificación de superficies, los revestimientos protectores, las películas funcionales, la tribología y las técnicas avanzadas de deposición"
    },
    "subfield:2600": {
      "name": "Matemáticas generales",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de las matemáticas y conecta los límites tradicionales de este campo"
    },
    "subfield:2602": {
      "name": "Álgebra y teoría de números",
      "description": "Estructuras algebraicas abstractas y propiedades de los números enteros, que incluyen los grupos, los anillos, los cuerpos, la geometría algebraica, la geometría aritmética y las aplicaciones a la criptografía y la teoría de códigos"
    },
    "subfield:2604": {
      "name": "Matemáticas aplicadas",
      "description": "Métodos matemáticos para problemas del mundo real, que incluyen las ecuaciones diferenciales, la optimización, la modelización matemática, los sistemas dinámicos y las aplicaciones en ciencia, ingeniería e industria"
    },
    "subfield:2605": {
      "name": "Matemáticas computacionales",
      "description": "Algoritmos numéricos y técnicas computacionales, que incluyen el análisis numérico, la computación científica, la computación de alto rendimiento, el álgebra computacional y el desarrollo de software matemático"
    },
    "subfield:2607": {
      "name": "Matemáticas discretas y combinatoria",
      "description": "Las matemáticas de las estructuras discretas, que incluyen la teoría de grafos, la optimización combinatoria, la teoría de códigos, la geometría discreta y las aplicaciones a las ciencias de la computación y la investigación de operaciones"
    },
    "subfield:2608": {
      "name": "Geometría y topología",
      "description": "El estudio de la forma, el espacio y las deformaciones continuas, que incluye la geometría diferencial, la topología algebraica, el análisis geométrico y las aplicaciones a la física y el análisis de datos"
    },
    "subfield:2610": {
      "name": "Física matemática",
      "description": "Los fundamentos matemáticos de las teorías físicas, que incluyen la mecánica cuántica, la mecánica estadística, la relatividad general, la teoría de cuerdas y el desarrollo de marcos matemáticos rigurosos para la física"
    },
    "subfield:2611": {
      "name": "Modelización y simulación",
      "description": "La representación matemática y la simulación por computadora de sistemas complejos, que incluyen los modelos basados en agentes, los métodos de Montecarlo, la dinámica de sistemas y la validación de modelos computacionales"
    },
    "subfield:2612": {
      "name": "Análisis numérico",
      "description": "El desarrollo y análisis de algoritmos de cálculo numérico, que incluye el análisis de errores, la estabilidad, la convergencia y los métodos eficientes para resolver problemas matemáticos mediante computación"
    },
    "subfield:2613": {
      "name": "Estadística y probabilidad",
      "description": "Marcos matemáticos para el análisis de datos y la incertidumbre, que incluyen la teoría estadística, la teoría de la probabilidad, los procesos estocásticos, la inferencia estadística y las aplicaciones a la ciencia de datos"
    },
    "subfield:2614": {
      "name": "Ciencias de la computación teóricas",
      "description": "Los aspectos matemáticos de la computación, que incluyen los algoritmos, la complejidad computacional, la teoría de autómatas, los métodos formales, la teoría de la computación cuántica y los fundamentos de las ciencias de la computación"
    },
    "subfield:2700": {
      "name": "Medicina general",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de la medicina y conecta los límites tradicionales de este campo"
    },
    "subfield:2702": {
      "name": "Anatomía",
      "description": "La estructura del cuerpo humano, que incluye la anatomía macroscópica, la histología, la embriología, la neuroanatomía y la aplicación de los conocimientos anatómicos a la práctica clínica y la formación médica"
    },
    "subfield:2703": {
      "name": "Anestesiología y medicina del dolor",
      "description": "La práctica de la anestesia y el tratamiento del dolor, que incluye la atención perioperatoria, la anestesia regional, los cuidados intensivos, el tratamiento del dolor crónico y el desarrollo de nuevos enfoques analgésicos"
    },
    "subfield:2704": {
      "name": "Bioquímica",
      "description": "La base química de los procesos fisiológicos y patológicos, que incluye la bioquímica clínica, las vías metabólicas, el diagnóstico molecular y los mecanismos bioquímicos de las enfermedades"
    },
    "subfield:2705": {
      "name": "Cardiología y medicina cardiovascular",
      "description": "El estudio y tratamiento de las enfermedades cardíacas y vasculares, que incluye la enfermedad coronaria, la insuficiencia cardíaca, las arritmias, la cardiología intervencionista y la prevención cardiovascular"
    },
    "subfield:2706": {
      "name": "Medicina crítica y de cuidados intensivos",
      "description": "El tratamiento de pacientes en estado crítico, que incluye la ventilación mecánica, el apoyo hemodinámico, el tratamiento de la sepsis, la insuficiencia orgánica y las innovaciones en las prácticas de las unidades de cuidados intensivos"
    },
    "subfield:2707": {
      "name": "Medicina complementaria y alternativa",
      "description": "Prácticas médicas no convencionales, que incluyen la medicina tradicional, la acupuntura, la fitoterapia, las terapias mente-cuerpo y la integración de enfoques complementarios con la medicina convencional"
    },
    "subfield:2708": {
      "name": "Dermatología",
      "description": "El diagnóstico y tratamiento de trastornos de la piel, incluidas las enfermedades cutáneas inflamatorias, el cáncer de piel, la dermatología estética, la dermatología pediátrica y la cirugía dermatológica"
    },
    "subfield:2711": {
      "name": "Medicina de urgencias",
      "description": "La atención médica aguda en entornos de urgencias, que incluye el tratamiento de traumatismos, la reanimación, los procedimientos de urgencia, la medicina de catástrofes y la organización de los servicios médicos de urgencias"
    },
    "subfield:2712": {
      "name": "Endocrinología, diabetes y metabolismo",
      "description": "Trastornos hormonales y enfermedades metabólicas, que incluyen la diabetes mellitus, los trastornos tiroideos, la obesidad, el síndrome metabólico y la regulación endocrina del metabolismo"
    },
    "subfield:2713": {
      "name": "Epidemiología",
      "description": "Los patrones y las causas de las enfermedades en las poblaciones, que incluyen la vigilancia epidemiológica, la investigación de brotes, los ensayos clínicos, las desigualdades en salud y el desarrollo de intervenciones de salud pública"
    },
    "subfield:2714": {
      "name": "Medicina familiar",
      "description": "Atención primaria integral durante toda la vida, que incluye la medicina preventiva, el tratamiento de enfermedades crónicas, la atención centrada en el paciente y la coordinación de los servicios sanitarios"
    },
    "subfield:2715": {
      "name": "Gastroenterología",
      "description": "Enfermedades del aparato digestivo, incluidas la enfermedad inflamatoria intestinal, las enfermedades hepáticas, los cánceres gastrointestinales, la endoscopia y los trastornos gastrointestinales funcionales"
    },
    "subfield:2716": {
      "name": "Genética",
      "description": "Genética médica y medicina genómica, que incluyen las pruebas genéticas, las enfermedades hereditarias, la farmacogenómica, el asesoramiento genético y la aplicación de la genómica a la medicina personalizada"
    },
    "subfield:2717": {
      "name": "Geriatría y gerontología",
      "description": "Atención sanitaria para personas mayores, que incluye las enfermedades relacionadas con la edad, la fragilidad, el deterioro cognitivo, la polifarmacia, los cuidados de larga duración y las estrategias para un envejecimiento saludable"
    },
    "subfield:2718": {
      "name": "Informática de la salud",
      "description": "Tecnología de la información en la atención sanitaria, que incluye las historias clínicas electrónicas, el apoyo a las decisiones clínicas, la telemedicina, el análisis de datos sanitarios y el uso de la IA en medicina"
    },
    "subfield:2720": {
      "name": "Hematología",
      "description": "Trastornos y enfermedades de la sangre, que incluyen la anemia, los trastornos hemorrágicos, la trombosis, las neoplasias hematológicas, la medicina transfusional y el trasplante de células madre"
    },
    "subfield:2721": {
      "name": "Hepatología",
      "description": "Enfermedades y trastornos del hígado, que incluyen la hepatitis vírica, la cirrosis, la enfermedad del hígado graso, el cáncer de hígado, el trasplante hepático y el tratamiento de la hipertensión portal"
    },
    "subfield:2723": {
      "name": "Inmunología y alergología",
      "description": "Trastornos del sistema inmunitario y enfermedades alérgicas, que incluyen las enfermedades autoinmunes, las inmunodeficiencias, la rinitis alérgica, el asma, la anafilaxia y los enfoques de inmunoterapia"
    },
    "subfield:2724": {
      "name": "Medicina interna",
      "description": "Medicina integral de adultos, que incluye el diagnóstico y tratamiento de afecciones médicas complejas, la medicina hospitalaria, la atención preventiva y la coordinación de la atención de subespecialidades"
    },
    "subfield:2725": {
      "name": "Enfermedades infecciosas",
      "description": "La prevención y el tratamiento de infecciones, que incluyen la terapia antimicrobiana, las enfermedades infecciosas emergentes, las infecciones hospitalarias, la medicina tropical y el desarrollo de vacunas"
    },
    "subfield:2726": {
      "name": "Microbiología",
      "description": "Microbiología médica y agentes infecciosos, incluidos los patógenos bacterianos, víricos, fúngicos y parasitarios, la resistencia a los antimicrobianos, la microbiología diagnóstica y el control de infecciones"
    },
    "subfield:2727": {
      "name": "Nefrología",
      "description": "Enfermedades y trastornos renales, que incluyen la enfermedad renal crónica, la lesión renal aguda, la diálisis, el trasplante renal, los trastornos electrolíticos y la hipertensión"
    },
    "subfield:2728": {
      "name": "Neurología",
      "description": "Enfermedades del sistema nervioso, que incluyen el accidente cerebrovascular, la epilepsia, los trastornos del movimiento, las enfermedades neurodegenerativas, las cefaleas y la aplicación de la neuroimagen al diagnóstico"
    },
    "subfield:2729": {
      "name": "Obstetricia y ginecología",
      "description": "Salud reproductiva de la mujer, que incluye la atención durante el embarazo, el parto, los trastornos ginecológicos, la endocrinología reproductiva, la oncología ginecológica y la medicina materno-fetal"
    },
    "subfield:2730": {
      "name": "Oncología",
      "description": "Diagnóstico y tratamiento del cáncer, que incluyen la oncología médica, radioterápica y quirúrgica, la inmunoterapia del cáncer, la oncología de precisión y los cuidados paliativos"
    },
    "subfield:2731": {
      "name": "Oftalmología",
      "description": "Enfermedades oculares y trastornos de la visión, que incluyen las cataratas, el glaucoma, las enfermedades de la retina, la cirugía refractiva, la oftalmología pediátrica y los avances en cirugía oftálmica"
    },
    "subfield:2732": {
      "name": "Ortopedia y medicina deportiva",
      "description": "Trastornos y lesiones musculoesqueléticos, que incluyen el reemplazo articular, la cirugía de columna, las lesiones deportivas, la cirugía de traumatismos, la ortopedia pediátrica y la rehabilitación"
    },
    "subfield:2733": {
      "name": "Otorrinolaringología",
      "description": "Trastornos del oído, la nariz y la garganta, que incluyen la pérdida auditiva, la sinusitis, los trastornos de la voz, el cáncer de cabeza y cuello, la otorrinolaringología pediátrica y los avances en cirugía otorrinolaringológica"
    },
    "subfield:2734": {
      "name": "Patología y medicina forense",
      "description": "Diagnóstico de enfermedades mediante análisis de laboratorio, que incluye la patología anatómica, clínica y molecular, la autopsia y la aplicación de la patología a investigaciones legales"
    },
    "subfield:2735": {
      "name": "Pediatría, perinatología y salud infantil",
      "description": "Atención sanitaria para bebés, niños y adolescentes, que incluye la neonatología, la pediatría del desarrollo, las subespecialidades pediátricas, las vacunas infantiles y la medicina de la adolescencia"
    },
    "subfield:2736": {
      "name": "Farmacología",
      "description": "La acción de los fármacos y la terapéutica, que incluyen la farmacología clínica, el desarrollo de fármacos, la farmacocinética, la farmacodinámica, las reacciones adversas y los enfoques de medicina personalizada"
    },
    "subfield:2737": {
      "name": "Fisiología",
      "description": "La función y regulación normales del organismo, que incluyen la fisiología cardiovascular, respiratoria y del ejercicio, la neurofisiología y la base fisiológica de las enfermedades"
    },
    "subfield:2738": {
      "name": "Psiquiatría y salud mental",
      "description": "Trastornos de salud mental y su tratamiento, que incluyen los trastornos del estado de ánimo, psicóticos y de ansiedad, la psicoterapia, la psicofarmacología y la salud mental comunitaria"
    },
    "subfield:2739": {
      "name": "Salud pública, ambiental y ocupacional",
      "description": "Salud y prevención de la población, que incluyen la promoción de la salud, la prevención de enfermedades, los peligros ambientales para la salud, la seguridad ocupacional, la política sanitaria y las iniciativas de salud mundial"
    },
    "subfield:2740": {
      "name": "Medicina pulmonar y respiratoria",
      "description": "Enfermedades pulmonares y trastornos respiratorios, que incluyen el asma, la EPOC, la neumonía, el cáncer de pulmón, los trastornos del sueño, la hipertensión pulmonar y la neumología de cuidados intensivos"
    },
    "subfield:2741": {
      "name": "Radiología, medicina nuclear e imagen",
      "description": "Imágenes médicas y procedimientos guiados por imagen, que incluyen la radiología diagnóstica e intervencionista, la medicina nuclear, la planificación de radioterapia y los avances en tecnología de imagen"
    },
    "subfield:2742": {
      "name": "Rehabilitación",
      "description": "La recuperación de la función tras una enfermedad o lesión, que incluye la medicina física, la terapia ocupacional, la logopedia, la rehabilitación cardíaca y la tecnología de asistencia"
    },
    "subfield:2743": {
      "name": "Medicina reproductiva",
      "description": "Fertilidad y salud reproductiva, que incluyen el tratamiento de la infertilidad, la tecnología de reproducción asistida, la endocrinología reproductiva, la anticoncepción y la preservación de la fertilidad"
    },
    "subfield:2745": {
      "name": "Reumatología",
      "description": "Enfermedades articulares autoinmunes e inflamatorias, que incluyen la artritis reumatoide, el lupus, la artrosis, la gota, la vasculitis y el desarrollo de terapias dirigidas"
    },
    "subfield:2746": {
      "name": "Cirugía",
      "description": "Tratamiento quirúrgico de enfermedades y lesiones, que incluye la cirugía general, mínimamente invasiva, robótica, de trasplantes y oncológica, así como la atención perioperatoria"
    },
    "subfield:2747": {
      "name": "Trasplantes",
      "description": "Trasplante de órganos y tejidos, que incluye la selección de donantes, la inmunosupresión, la prevención del rechazo, la conservación de órganos, los xenotrasplantes y los resultados de los trasplantes"
    },
    "subfield:2748": {
      "name": "Urología",
      "description": "Trastornos de las vías urinarias y del aparato reproductor masculino, que incluyen las enfermedades de la próstata, los cálculos renales, el cáncer de vejiga, la disfunción eréctil, la urología pediátrica y la cirugía urológica"
    },
    "subfield:2800": {
      "name": "Neurociencia general",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de la neurociencia y conecta los límites tradicionales de este campo"
    },
    "subfield:2802": {
      "name": "Neurociencia del comportamiento",
      "description": "Mecanismos neurales subyacentes al comportamiento, que incluyen el aprendizaje, la memoria, la motivación, las emociones, la adicción y el uso de modelos animales para comprender los trastornos del comportamiento humano"
    },
    "subfield:2803": {
      "name": "Psiquiatría biológica",
      "description": "La base biológica de los trastornos psiquiátricos, que incluye los sistemas de neurotransmisores, la neuroimagen en psiquiatría, los factores genéticos, la psicofarmacología y los biomarcadores de enfermedades mentales"
    },
    "subfield:2804": {
      "name": "Neurociencia celular y molecular",
      "description": "Mecanismos moleculares y celulares del funcionamiento del sistema nervioso, que incluyen la transmisión sináptica, los canales iónicos, los receptores de neurotransmisores, la transducción de señales y el desarrollo neuronal"
    },
    "subfield:2805": {
      "name": "Neurociencia cognitiva",
      "description": "La base neural de las funciones cognitivas, que incluye la atención, la percepción, el lenguaje, la toma de decisiones, la función ejecutiva y el uso de la neuroimagen para estudiar la cognición humana"
    },
    "subfield:2806": {
      "name": "Neurociencia del desarrollo",
      "description": "El desarrollo del sistema nervioso, que incluye la neurogénesis, la guía axonal, la formación de sinapsis, la plasticidad neural y los trastornos del desarrollo del sistema nervioso"
    },
    "subfield:2807": {
      "name": "Sistemas endocrino y autónomo",
      "description": "La regulación neuroendocrina y la función autónoma, que incluyen las respuestas al estrés, los ritmos circadianos, los trastornos autonómicos y la interacción entre los sistemas nervioso y endocrino"
    },
    "subfield:2808": {
      "name": "Neurología",
      "description": "Neurociencia clínica y trastornos neurológicos, que incluyen la neurodegeneración, la neuroinmunología, las enfermedades neuromusculares y los enfoques traslacionales del tratamiento neurológico"
    },
    "subfield:2809": {
      "name": "Sistemas sensoriales",
      "description": "El procesamiento neural de la información sensorial, que incluye la visión, la audición, el tacto, el gusto, el olfato, la percepción del dolor y el desarrollo de prótesis e interfaces sensoriales"
    },
    "subfield:2900": {
      "name": "Enfermería general",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de la enfermería y conecta los límites tradicionales de este campo"
    },
    "subfield:2910": {
      "name": "Cuestiones éticas y aspectos legales",
      "description": "Consideraciones éticas y legales en la práctica de enfermería, que incluyen los derechos del paciente, el consentimiento informado, los cuidados al final de la vida, la ética profesional y la legislación sanitaria que afecta a la enfermería"
    },
    "subfield:2911": {
      "name": "Liderazgo y gestión",
      "description": "Liderazgo de enfermería y gestión sanitaria, que incluyen la gestión de enfermería, la mejora de la calidad asistencial, el comportamiento organizacional, la gestión del cambio y el desarrollo del personal de enfermería"
    },
    "subfield:2916": {
      "name": "Nutrición y dietética",
      "description": "Ciencias de la nutrición y gestión dietética, que incluyen la nutrición clínica y comunitaria, la gestión de servicios de alimentación, el asesoramiento nutricional y el papel de la dieta en la salud y las enfermedades"
    },
    "subfield:2922": {
      "name": "Investigación y teoría",
      "description": "Metodología de investigación en enfermería y marcos teóricos, que incluyen la práctica basada en la evidencia, las teorías de enfermería, el diseño de investigaciones, los métodos cualitativos y cuantitativos y la transferencia del conocimiento"
    },
    "subfield:3000": {
      "name": "Farmacología, toxicología y ciencias farmacéuticas generales",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de la farmacología, la toxicología y las ciencias farmacéuticas y conecta los límites tradicionales de este campo"
    },
    "subfield:3002": {
      "name": "Descubrimiento de fármacos",
      "description": "La identificación y el desarrollo de nuevos compuestos terapéuticos, que incluyen la identificación de dianas, la optimización de compuestos candidatos, el cribado de alto rendimiento y el diseño computacional de fármacos"
    },
    "subfield:3003": {
      "name": "Ciencias farmacéuticas",
      "description": "La formulación y administración de fármacos, que incluyen la farmacia galénica, la farmacocinética, la estabilidad de los fármacos, los sistemas de liberación controlada y el desarrollo de nuevas tecnologías de administración"
    },
    "subfield:3004": {
      "name": "Farmacología",
      "description": "La acción y los efectos de los fármacos en los sistemas biológicos, que incluyen la farmacología molecular, la neurofarmacología, la farmacología cardiovascular, las interacciones entre fármacos y receptores y las reacciones adversas"
    },
    "subfield:3005": {
      "name": "Toxicología",
      "description": "El estudio de los efectos adversos de las sustancias químicas, que incluye los mecanismos de toxicidad, la evaluación de riesgos, la toxicología ambiental y forense y la toxicología regulatoria"
    },
    "subfield:3100": {
      "name": "Física y astronomía generales",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de la física y la astronomía y conecta los límites tradicionales de este campo"
    },
    "subfield:3102": {
      "name": "Acústica y ultrasonidos",
      "description": "La física del sonido y los ultrasonidos, que incluye la propagación de ondas, los materiales acústicos, el control del ruido, las imágenes por ultrasonidos, los metamateriales acústicos y las aplicaciones en medicina e industria"
    },
    "subfield:3103": {
      "name": "Astronomía y astrofísica",
      "description": "El estudio de los objetos celestes y los fenómenos cósmicos, que incluye la evolución estelar, las galaxias, la cosmología, los exoplanetas, las ondas gravitacionales y las técnicas de astronomía observacional"
    },
    "subfield:3104": {
      "name": "Física de la materia condensada",
      "description": "La física de la materia sólida y líquida, que incluye los semiconductores, los superconductores, el magnetismo, las transiciones de fase, la nanofísica y los materiales cuánticos"
    },
    "subfield:3105": {
      "name": "Instrumentación",
      "description": "El desarrollo de instrumentos científicos y técnicas de medición, que incluye los detectores, los sensores, los sistemas de imagen, las mediciones de precisión y la instrumentación para instalaciones de investigación"
    },
    "subfield:3106": {
      "name": "Física nuclear y de altas energías",
      "description": "Partículas fundamentales y física nuclear, que incluyen los aceleradores de partículas, los quarks y leptones, la estructura nuclear, los detectores de partículas y la búsqueda de nueva física"
    },
    "subfield:3107": {
      "name": "Física atómica y molecular y óptica",
      "description": "La física de los átomos, las moléculas y la luz, que incluye la óptica cuántica, la física de láseres, la espectroscopia, la fotónica, la información cuántica y las tecnologías ópticas"
    },
    "subfield:3108": {
      "name": "Radiación",
      "description": "La física y las aplicaciones de la radiación ionizante, que incluyen la detección de radiación, la dosimetría, la radioterapia, la protección radiológica y la física de la medicina nuclear"
    },
    "subfield:3109": {
      "name": "Física estadística y no lineal",
      "description": "Sistemas complejos y física estadística, que incluyen la teoría del caos, las redes complejas, la física de la materia blanda, la biofísica y los fenómenos emergentes en sistemas de muchos cuerpos"
    },
    "subfield:3200": {
      "name": "Psicología general",
      "description": "Temas amplios de psicología que abarcan múltiples subcampos, incluidas la teoría psicológica, la historia de la psicología, los métodos de investigación y los enfoques integradores para comprender el comportamiento"
    },
    "subfield:3202": {
      "name": "Psicología aplicada",
      "description": "Aplicaciones prácticas de los principios psicológicos, que incluyen la psicología industrial y organizacional, la psicología forense, deportiva, ambiental y del consumidor"
    },
    "subfield:3203": {
      "name": "Psicología clínica",
      "description": "Evaluación y tratamiento de los trastornos de salud mental, que incluyen la psicoterapia, las pruebas psicológicas, las intervenciones clínicas, los tratamientos basados en la evidencia y los servicios de salud mental"
    },
    "subfield:3204": {
      "name": "Psicología del desarrollo y de la educación",
      "description": "El desarrollo y el aprendizaje humanos durante toda la vida, que incluyen el desarrollo cognitivo y social, las intervenciones educativas, las dificultades de aprendizaje y la psicología escolar"
    },
    "subfield:3205": {
      "name": "Psicología experimental y cognitiva",
      "description": "Procesos psicológicos básicos, que incluyen la percepción, la atención, la memoria, el pensamiento, la resolución de problemas, el procesamiento del lenguaje y los métodos experimentales en psicología"
    },
    "subfield:3206": {
      "name": "Neuropsicología y psicología fisiológica",
      "description": "Relaciones entre el cerebro y el comportamiento, que incluyen la neuropsicología cognitiva y clínica, la psicofisiología, la neuroimagen en psicología y las bases biológicas del comportamiento"
    },
    "subfield:3207": {
      "name": "Psicología social",
      "description": "Cómo piensan las personas sobre los demás e interactúan con ellos, que incluye las actitudes, la cognición social, la dinámica de grupos, los prejuicios, las relaciones interpersonales y la psicología cultural"
    },
    "subfield:3300": {
      "name": "Ciencias sociales generales",
      "description": "Investigación interdisciplinaria en ciencias sociales, que incluye enfoques de métodos mixtos, teoría social, estudios comparativos e investigación sobre problemas sociales complejos"
    },
    "subfield:3302": {
      "name": "Arqueología",
      "description": "El estudio del pasado humano mediante restos materiales, que incluye los métodos de excavación, el análisis de objetos, la gestión del patrimonio cultural y la reconstrucción de sociedades antiguas"
    },
    "subfield:3303": {
      "name": "Desarrollo",
      "description": "El desarrollo internacional y el cambio social, que incluyen el desarrollo económico y sostenible, la reducción de la pobreza, la política de desarrollo y la desigualdad mundial"
    },
    "subfield:3304": {
      "name": "Educación",
      "description": "La teoría y la práctica educativas, que incluyen el desarrollo curricular, la política educativa, la formación del profesorado, la tecnología educativa, la evaluación y la educación comparada"
    },
    "subfield:3305": {
      "name": "Geografía, planificación y desarrollo",
      "description": "Los aspectos espaciales de la sociedad humana, que incluyen la geografía humana, la planificación urbana, el desarrollo regional, las aplicaciones de SIG, la planificación ambiental y el desarrollo sostenible"
    },
    "subfield:3306": {
      "name": "Salud",
      "description": "Las dimensiones sociales de la salud y la atención sanitaria, que incluyen la sociología de la salud, la antropología médica, la política sanitaria, las desigualdades en salud y los determinantes sociales de la salud"
    },
    "subfield:3307": {
      "name": "Factores humanos y ergonomía",
      "description": "El diseño de sistemas para el uso humano, que incluye la ergonomía laboral, la interacción persona-máquina, la ingeniería de seguridad, la ergonomía cognitiva y el diseño centrado en el usuario"
    },
    "subfield:3308": {
      "name": "Derecho",
      "description": "Los sistemas jurídicos y la jurisprudencia, que incluyen el derecho comparado, internacional y constitucional, la teoría jurídica, el derecho y la sociedad y los estudios jurídicos interdisciplinarios"
    },
    "subfield:3309": {
      "name": "Biblioteconomía y ciencias de la información",
      "description": "La organización y el acceso a la información, que incluyen las bibliotecas digitales, la recuperación de información, la organización del conocimiento, la alfabetización informacional, los archivos y la política de información"
    },
    "subfield:3310": {
      "name": "Lingüística y lengua",
      "description": "El estudio científico del lenguaje, que incluye la lingüística teórica, aplicada, psicolingüística y computacional, la documentación lingüística y el multilingüismo"
    },
    "subfield:3311": {
      "name": "Investigación sobre seguridad",
      "description": "La prevención de accidentes y lesiones, que incluye la seguridad laboral, del transporte y de los productos, la percepción del riesgo, la cultura de seguridad y la investigación de accidentes"
    },
    "subfield:3312": {
      "name": "Sociología y ciencias políticas",
      "description": "Las estructuras sociales y los procesos políticos, que incluyen los movimientos sociales, la sociología política, la desigualdad social, las relaciones de poder y la intersección entre sociedad y política"
    },
    "subfield:3313": {
      "name": "Transporte",
      "description": "El movimiento de personas y mercancías, que incluye la planificación del transporte, la ingeniería de tráfico, la logística, el transporte sostenible, la economía del transporte y los estudios de movilidad"
    },
    "subfield:3314": {
      "name": "Antropología",
      "description": "El estudio integral de la humanidad, que incluye la antropología cultural, física, lingüística, arqueológica y aplicada"
    },
    "subfield:3315": {
      "name": "Comunicación",
      "description": "Los procesos de comunicación humana y los medios, que incluyen la comunicación de masas e interpersonal, los medios digitales, el periodismo, las relaciones públicas y la tecnología de la comunicación"
    },
    "subfield:3316": {
      "name": "Estudios culturales",
      "description": "El análisis de la cultura y la sociedad contemporáneas, que incluye la cultura popular, los estudios de medios y poscoloniales, la teoría crítica y la política de la representación"
    },
    "subfield:3317": {
      "name": "Demografía",
      "description": "Los estudios y la dinámica de la población, que incluyen la fecundidad, la mortalidad, la migración, el envejecimiento poblacional, los métodos demográficos y las implicaciones sociales y económicas del cambio demográfico"
    },
    "subfield:3318": {
      "name": "Estudios de género",
      "description": "El estudio del género y la sexualidad, que incluye la teoría feminista, los estudios de las masculinidades y LGBTQ+, la desigualdad de género y la intersección del género con otras categorías sociales"
    },
    "subfield:3319": {
      "name": "Estudios del ciclo vital y el curso de vida",
      "description": "El desarrollo humano a lo largo del curso de vida, que incluye los estudios sobre el envejecimiento, las transiciones vitales, las relaciones intergeneracionales, la epidemiología del curso de vida y la investigación biográfica"
    },
    "subfield:3320": {
      "name": "Ciencias políticas y relaciones internacionales",
      "description": "La política y la gobernanza en todos los niveles, que incluyen la política comparada, las relaciones internacionales, la teoría política, la política pública, la diplomacia y la gobernanza mundial"
    },
    "subfield:3321": {
      "name": "Administración pública",
      "description": "Las operaciones gubernamentales y la gestión pública, que incluyen la implantación de políticas públicas, la burocracia, la reforma del sector público, el gobierno electrónico y la gestión de organizaciones sin fines de lucro"
    },
    "subfield:3322": {
      "name": "Estudios urbanos",
      "description": "Las ciudades y los procesos de urbanización, que incluyen la sociología y la economía urbanas, los estudios de vivienda, la gobernanza urbana, las ciudades inteligentes y la sostenibilidad urbana"
    },
    "subfield:3400": {
      "name": "Veterinaria general",
      "description": "Investigación interdisciplinaria que abarca múltiples áreas de la veterinaria y conecta los límites tradicionales de este campo"
    },
    "subfield:3402": {
      "name": "Medicina equina",
      "description": "Salud y medicina equinas, que incluyen la cirugía, la medicina interna, la reproducción, la medicina deportiva y la nutrición equinas, así como el tratamiento de enfermedades y lesiones de los caballos"
    },
    "subfield:3404": {
      "name": "Pequeños animales",
      "description": "Medicina de animales de compañía, incluidos perros, gatos y mascotas exóticas, que abarca la medicina interna, la cirugía, el comportamiento, la nutrición y la atención preventiva de animales domésticos"
    },
    "subfield:3500": {
      "name": "Odontología general",
      "description": "Atención odontológica integral, que incluye la odontología preventiva, los procedimientos restauradores, el diagnóstico de enfermedades orales, la gestión del paciente y la prestación de atención odontológica primaria"
    },
    "subfield:3504": {
      "name": "Cirugía oral",
      "description": "Procedimientos quirúrgicos de la boca y la mandíbula, que incluyen la extracción de dientes, los implantes dentales, la cirugía maxilar, la patología oral, el tratamiento de traumatismos y la reconstrucción maxilofacial"
    },
    "subfield:3505": {
      "name": "Ortodoncia",
      "description": "Corrección de irregularidades dentales y faciales, que incluye los aparatos, los alineadores, la modificación del crecimiento maxilar, la ortodoncia quirúrgica y la biomecánica del movimiento dental"
    },
    "subfield:3506": {
      "name": "Periodoncia",
      "description": "Enfermedades de las encías y las estructuras de soporte de los dientes, que incluyen la gingivitis, la periodontitis, la cirugía de encías, los implantes dentales y los procedimientos periodontales regenerativos"
    },
    "subfield:3600": {
      "name": "Profesiones de la salud generales",
      "description": "Temas amplios de las profesiones sanitarias afines, que incluyen la educación interprofesional, los equipos sanitarios, el desarrollo profesional, la promoción de la salud y la prestación integrada de atención sanitaria"
    },
    "subfield:3603": {
      "name": "Terapias complementarias y manuales",
      "description": "Enfoques terapéuticos alternativos y manuales, que incluyen la quiropráctica, la terapia de masaje, la osteopatía, la acupuntura en profesiones sanitarias afines y las terapias manuales integradoras"
    },
    "subfield:3604": {
      "name": "Servicios médicos de urgencias",
      "description": "Atención de urgencias prehospitalaria, que incluye la práctica paramédica, la formación de técnicos de emergencias médicas, la respuesta ante catástrofes, la atención de traumatismos y la gestión de sistemas médicos de urgencias"
    },
    "subfield:3605": {
      "name": "Gestión de la información sanitaria",
      "description": "Gestión de datos sanitarios y sistemas de información, que incluye la codificación médica, la administración de historias clínicas, la privacidad de los datos, el análisis sanitario y la documentación clínica"
    },
    "subfield:3607": {
      "name": "Tecnología de laboratorio médico",
      "description": "Ciencias y diagnóstico de laboratorio clínico, que incluyen la química clínica, la hematología, la microbiología, la inmunología, el diagnóstico molecular y la gestión de la calidad del laboratorio"
    },
    "subfield:3608": {
      "name": "Terminología médica",
      "description": "Lenguaje y comunicación médicos, que incluyen la terminología anatómica, el vocabulario clínico, la documentación médica, las normas terminológicas y los sistemas de comunicación sanitaria"
    },
    "subfield:3609": {
      "name": "Terapia ocupacional",
      "description": "Ayudar a las personas a participar en actividades cotidianas mediante la evaluación funcional, los equipos adaptativos, la integración sensorial, la rehabilitación laboral y las intervenciones basadas en la ocupación"
    },
    "subfield:3611": {
      "name": "Farmacia",
      "description": "Terapia farmacológica y atención farmacéutica, que incluyen la farmacia clínica, comunitaria y hospitalaria, la seguridad de los medicamentos y la atención farmacéutica al paciente"
    },
    "subfield:3612": {
      "name": "Fisioterapia, terapia deportiva y rehabilitación",
      "description": "Ciencias del movimiento y rehabilitación, que incluyen la terapia musculoesquelética, la rehabilitación neurológica, el tratamiento de lesiones deportivas, la prescripción de ejercicio y la recuperación funcional"
    },
    "subfield:3614": {
      "name": "Tecnología radiológica y de ultrasonidos",
      "description": "Tecnología y práctica de imágenes médicas, que incluyen la radiografía, la ecografía, la TC, la RM, la seguridad radiológica, la calidad de imagen y los procedimientos de diagnóstico por imagen"
    },
    "subfield:3616": {
      "name": "Habla y audición",
      "description": "Trastornos de la comunicación y audiología, que incluyen la logopedia, la evaluación auditiva, los implantes cocleares, los trastornos de la deglución y la rehabilitación de la comunicación"
    }
  }
}
